module.exports = __webpack_public_path__ + "img/bcfw.812a0301.jpg";